import RestaurantOfferStore from '@components/offer/stores/RestaurantOfferStore';
import { Box, Divider } from '@mui/material';
import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import React, { Fragment } from 'react';
import FoodCategoryListItem from './FoodCategoryListItem';

interface FoodCategoryListProps {
    restaurantOfferStore: RestaurantOfferStore;
}

const FoodCategoryList: React.FC<FoodCategoryListProps> = observer(({ restaurantOfferStore }) => {
    const { selectedRestaurant, onFoodCategoryClick } = restaurantOfferStore;
    return (
        <Box display={"flex"} flexDirection={"column"}>
            {_.map(selectedRestaurant?.foodCategories, (foodCategory) => (
                <Fragment key={foodCategory.id}>
                    <FoodCategoryListItem

                        foodCategory={foodCategory}
                        onClick={onFoodCategoryClick} />
                    <Divider flexItem />
                </Fragment>
            ))}
        </Box>
    )
})

export default FoodCategoryList;